import { MediaAssetResponseDto } from '@/shared/api';

export enum ConversationMode {
  Agent = 'agent',
  AI = 'ai',
}

export enum ChatMessageType {
  User = 'user',
  Author = 'author',
  Assistant = 'assistant',
}

export type ChatMessage = {
  id: string;
  text: string;
  assets?: MediaAssetResponseDto[];
  created: {
    at: string;
    by: { type: ChatMessageType };
  };
  error?: boolean;
};
